define('home/views/ChannelLeadingUserView',[
    'underscore',
    'backbone-marionette',

    'home/mixins/withChannelAvatar',
    'home/mixins/withAllstarPopover',
    'home/templates/channelLeadingUser',
], function (
    _,
    Marionette,

    withChannelAvatar,
    withAllstarPopover,
    channelLeadingUserTemplate
) {
    'use strict';

    /**
     * A view showing a user that is a channel leader or moderator.
     *
     * Expects to be given a User model, and the following options:
     * channel - the channel for which this user is a leader
     * index - the index of this user in the list of leaders
     * showIndex - whether or not to display the index
     * hideModBadge - whether or not to display the mod badge, if this
     *                user is a moderator
     */
    var ChannelLeadingUserView = Marionette.ItemView.extend({
        template: channelLeadingUserTemplate,
        tagName: 'li',
        className: 'leader-list__item align align--middle',

        templateHelpers: function () {
            var moderatedForums = this.model.get('moderatedForums') || [];
            var primaryForum = this.channel && this.channel.primaryForum;

            return {
                isModerator: primaryForum && _.contains(moderatedForums, primaryForum.id),
                displayIndex: this.showIndex && this.index + 1,
                hideModBadge: this.hideModBadge,
            };
        },

        modelEvents: {
            'change:moderatedForums': 'render',
        },

        initialize: function (options) {
            options = options || {};
            this.channel = options.channel;
            this.index = options.index;
            this.showIndex = options.showIndex;
            this.hideModBadge = options.hideModBadge;
        },
    });

    withChannelAvatar.call(ChannelLeadingUserView.prototype);
    withAllstarPopover.call(ChannelLeadingUserView.prototype);

    return ChannelLeadingUserView;
});

